function normalizeNewlines(value) {
  return String(value ?? '').replace(/\r\n?/g, '\n');
}

export function markdownHeading(text) {
  const normalized = normalizeNewlines(text);
  if (normalized.includes('\n')) {
    return null;
  }
  const match = /^(#{1,6})([ \t]+)(.+)$/.exec(normalized);
  if (!match) {
    return null;
  }
  return {
    level: match[1].length,
    title: match[3],
  };
}

function appendBlank(lines) {
  if (lines.length > 0 && lines[lines.length - 1] !== '') {
    lines.push('');
  }
}

function appendNormalNode(lines, text, indent) {
  const normalized = normalizeNewlines(text);
  if (normalized === '') {
    lines.push(`${indent}-`);
    return;
  }

  const parts = normalized.split('\n');
  lines.push(`${indent}- ${parts[0]}`);
  const continuationIndent = `${indent}  `;
  for (const line of parts.slice(1)) {
    lines.push(line === '' ? '' : `${continuationIndent}${line}`);
  }
}

/**
 * Outline Editor のツリーを、見出しと2スペースのリストを組み合わせた
 * Wiki向けMarkdownへ変換する。
 */
export function outlineToMarkdown(rootIds, getNode, getChildren) {
  const lines = [];

  const renderNode = (id, listIndent, ancestorHeadingLevel = null) => {
    const node = getNode(id);
    if (!node) {
      return;
    }

    const heading = markdownHeading(node.text);
    let childListIndent = listIndent;
    let childHeadingLevel = ancestorHeadingLevel;

    if (heading) {
      const outputLevel = ancestorHeadingLevel === null ? heading.level : Math.min(ancestorHeadingLevel + 1, 7);

      appendBlank(lines);
      if (outputLevel <= 6) {
        lines.push(`${listIndent}${'#'.repeat(outputLevel)} ${heading.title}`);
        childHeadingLevel = outputLevel;
      } else {
        lines.push(`${listIndent}- **${heading.title}**`);
        childListIndent = `${listIndent}  `;
        childHeadingLevel = ancestorHeadingLevel;
      }
      appendBlank(lines);
    } else {
      appendNormalNode(lines, node.text, listIndent);
      childListIndent = `${listIndent}  `;
    }

    for (const childId of getChildren(id)) {
      renderNode(childId, childListIndent, childHeadingLevel);
    }
  };

  for (const id of rootIds || []) {
    renderNode(id, '', null);
  }

  while (lines[0] === '') {
    lines.shift();
  }
  while (lines[lines.length - 1] === '') {
    lines.pop();
  }
  return lines.join('\n');
}

export function subtreeToMarkdown(rootId, getNode, getChildren) {
  return outlineToMarkdown([rootId], getNode, getChildren);
}
